export interface GlobalValueState {
  isLoading: boolean;
  toast: ToastModel;
  confirm: ConfirmModel;
  activeMenu: string;
  isSignIn: boolean;
  preLoadingApp: boolean;
  isLoadingLocationParams: boolean;
  menuDescriptionModal: MenuDescriptionModal;
  visibleOrderGuestModal: boolean;
}
export interface MenuDescriptionModal{
  open:boolean;
  description: string;
}
export interface ToastModel {
  isShowToast: boolean;
  status: string;
  message: string;
  duration: number;
  type: ToastType;
}
export enum ToastType {
  success,
  warn,
  info,
  error,
  default,
  dark,
}
export interface ConfirmModel {
  onClose: any;
  onYes: any;
  isModal: boolean;
  title: string;
  message: string;
}
